import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SubscriptionPause } from '../../types/subscription-pause.types';
import { pauseBannerCopy } from '../../utils/subscription-pause.copy';

/**
 * Banner under a paused (red) or scheduled-pause (orange) membership. Renders nothing for any
 * other state. Shared by the Customers → Subscriptions cards and the lane subscription popups.
 *
 * @selector app-subscription-pause-notice
 * @input pause - The membership's pause block.
 */
@Component({
  selector: 'app-subscription-pause-notice',
  standalone: true,
  templateUrl: './subscription-pause-notice.component.html',
  styleUrls: ['./subscription-pause-notice.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SubscriptionPauseNoticeComponent {
  @Input() pause: SubscriptionPause | null = null;

  get text(): string {
    return pauseBannerCopy(this.pause);
  }
}
